const locale = {
  ERROR_TEXT:
    'Упс! Здається, у вас недостатньо прав для доступу до цієї сторінки. Будь ласка, зверніться до адміністратора або служби підтримки для отримання допомоги.',
};

export default locale;
